import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class IncExcKey extends BasicEntity {
description: TranslatedEmb;
inc: boolean | null;
key: string;
visionCode: string;
}

